<template>
  <div id="orgRegisterWx">
     <img class="register-bg" src="/static/img/registerSuc.svg" alt="">
    <div class="leftText">
      <div class="leftText-one">快速迅捷</div>
      <div class="leftText-two">让您的合作零风险</div>
      <div class="leftText-three">为您保驾护航</div>
    </div>
    <div class="form-box">
         <OrgRegisterWxBind
      operType="BIND"
      wxData="wxData"
    />
    </div>
    <!--<OrgRegisterWxBind
      operType="BIND"
      wxData="wxData"
    /> -->
  </div>
</template>
<script>
import OrgRegisterWxBind from '@/components/org/register/OrgRegisterWxBind';
import eventBus from '@/plugins/event-bus';
import { saveRegisterInfo, saveRegisterSucInfo } from '@/services/org/depart-register-service';
export default {
  props: {
    orgData: {}
  },
  components: {
    OrgRegisterWxBind
  },
  data() {
    return {
      wxData: {
        openid: '',
        unionid: '',
        nickname: '',
        headimgurl: ''
      }
    };
  },
  created() {
    eventBus.$on('saveRegisterWxSuc', this.saveRegisterWxSuc);
  },
  methods: {
    saveRegisterWxSuc: function(wxData) {
      Object.assign(this.orgData, wxData);
      if (this.orgData.saveType === 1) {
        this.saveRegisterSuc(); // 自动注册成功
      } else {
        this.saveRegisterInfoService();
      }
    },
    async saveRegisterInfoService() {
      this.$root.layout.isLoading = true;
      this.isBtnLoading = true;
      let params = this.orgData;
      try {
        let { data } = await saveRegisterInfo(params);
        if (data.returnCode === '01') {
          this.$emit('onSuccessRegister');
        } else if (data.returnCode === '02') {
          this.$ebConfirm('您输入的机构名称已存在，点击确定返回修改')
            .then(() => {
              this.$router.push('/org/register/stepone');
            })
            .catch(() => {});
        } else if (data.returnCode === '03') {
          this.$ebConfirm('手机号已注册，点击确定返回修改')
            .then(() => {
              this.$router.push('/org/register/steptwo');
            })
            .catch(() => {});
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.isBtnLoading = false;
      this.$root.layout.isLoading = false;
    },
    async saveRegisterSuc() {
      this.isBtnLoading = true;
      let params = this.orgData;
      try {
        let { data } = await saveRegisterSucInfo(params);
        if (data.returnCode === '01') {
          this.$emit('onSuccessPass');
        } else if (data.returnCode === '02') {
          this.$ebConfirm('您输入的机构名称已存在，点击确定返回修改')
            .then(() => {
              this.$router.push('/org/register/stepone');
            })
            .catch(() => {});
        } else if (data.returnCode === '03') {
          this.$ebConfirm('手机号已注册，点击确定返回修改')
            .then(() => {
              this.$router.push('/org/register/steptwo');
            })
            .catch(() => {});
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.isBtnLoading = false;
    }
  },
  beforeDestroy() {
    eventBus.$off('saveRegisterWxSuc');
  }
};
</script>
<style lang="less" scoped>
#orgRegisterWx {
  font-family: 'Microsoft YaHei';
  position: relative;
  .register-bg {
    position: absolute;
    width: 481px;
    top: 156px;
    left: 150px;
  }
  .leftText {
    position: absolute;
    top: 561px;
    left: 521px;
    color: #fb5b3b;
    text-align: right;
    font-size: 18px;
    line-height: 28px;
    .leftText-one {
      font-size: 48px;
      line-height: 65px;
    }
  }
  .form-box {
    height: 622px;
    width: 491px;
    background-color: #fff;
    position: absolute;
    top: 56px;
    right: 133px;
    box-shadow: 6px 6px 6px #939393;
    overflow: hidden;
    // padding: 25px;
    .form-title {
      color: #fb5b3b;
      font-size: 24px;
      margin-bottom: 38px;
      .title-right {
        color: #a7a6a6;
        font-size: 14px;
      }
    }
    .successImg {
      height: 80px;
      padding-top: 82px;
      padding-left: 106px;
      background: url(../../../assets/img/register-success.jpg) no-repeat 36px 50px;
      font-size: 18px;
      font-weight: bold;
    }
    .successMessage {
      width: 343px;
      color: #6b6b6b;
      padding-left: 37px;
      line-height: 30px;
    }
    .userInfo {
      padding-bottom: 57px;
      .userInfoRow {
        display: flex;
        padding-left: 36px;
        line-height: 30px;
      }
      .userInfoRow-left {
        font-weight: bold;
        width: 120px;
      }
      .userInfoRow-middle {
        font-weight: bold;
        padding-right: 2px;
      }
      .userInfoRow-right {
        color: #fb5b3b;
      }
    }
    .submitForm {
      height: 40px;
    }
  }
}
</style>
